/* Centralized CSS imports for Label Function components */

import layoutStyles from './LabelLayout.module.css';
import formStyles from './LabelForms.module.css';
import previewStyles from './LabelPreview.module.css';
import tracerLabelLayoutStyles from './TracerLabelLayout.module.css';
import tracerLabelTypographyStyles from './TracerLabelTypography.module.css';
import componentStyles from './LabelComponents.module.css';

// Combine all styles into a single object for backward compatibility
const styles = {
  ...layoutStyles,
  ...formStyles,
  ...previewStyles,
  ...tracerLabelLayoutStyles,
  ...tracerLabelTypographyStyles,
  ...componentStyles,
};

export default styles;
